import { render, staticRenderFns } from "./upLoadImgs.vue?vue&type=template&id=b927648c&scoped=true&"
import script from "./upLoadImgs.vue?vue&type=script&lang=js&"
export * from "./upLoadImgs.vue?vue&type=script&lang=js&"
import style0 from "./upLoadImgs.vue?vue&type=style&index=0&id=b927648c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b927648c",
  null
  
)

export default component.exports